import { createAsyncThunk } from '@reduxjs/toolkit'
import { Auth, ErrorStore, User } from '@types'
import {
  STORE_AUTH,
  STORE_AUTH_FETCH_USER,
  STORE_STATUS_INITIALIZED,
} from 'constants/store'
import {
  createGenericSlice,
  createReducers,
  ExtraReducers,
  GenericState,
} from 'stores/generics'

import { Payload } from 'stores'

export type AuthUserState = Auth

type State = GenericState<AuthUserState>

export const initialState: State = {
  data: {
    displayName: '',
    email: '',
    uid: '',
    photoURL: '',
    token: '',
    isAnonymous: false,
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchAuth = createAsyncThunk<AuthUserState, any, Payload>(
  STORE_AUTH_FETCH_USER,
  async (promise, { rejectWithValue }) => {
    try {
      return await promise
    } catch (e: any) {
      const { code, message } = e as ErrorStore
      return rejectWithValue({ code, message })
    }
  }
)

const extraReducers: ExtraReducers = createReducers<
  AuthUserState,
  User,
  Payload
>(fetchAuth, initialState.data)

const authSlice = createGenericSlice({
  name: STORE_AUTH,
  initialState,
  reducers: {},
  extraReducers,
})

const { actions, reducer } = authSlice

const { clear } = actions

export { clear }

export default reducer
